import { render, staticRenderFns } from "./Modulo.vue?vue&type=template&id=0f95fa38&scoped=true"
import script from "./Modulo.vue?vue&type=script&lang=js"
export * from "./Modulo.vue?vue&type=script&lang=js"
import style0 from "./Modulo.vue?vue&type=style&index=0&id=0f95fa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95fa38",
  null
  
)

export default component.exports